<figure
  class="highcharts-figure"
  data-automation="optima-savings-revenues-treemap"
>
  <div id="{{ chartId }}"></div>
</figure>
